module.exports = __webpack_public_path__ + "static/media/DSC09110_20180710_017-3.40e19d6a.jpg";